import { ControlledDialog } from '@zoopla-eng/zds/dialog';
import { RefObject } from 'react';
import {
    SearchInitiationMobileModal,
    SearchInitiationMobileModalProps
} from '../SearchInitiationMobileModal';
import { contentWrapperStyle } from './ModalManager.styles.css';

interface ModalManagerProps {
    isModalShowing: boolean;
    closeModal: () => void;
    modalProps: Omit<SearchInitiationMobileModalProps, 'close'>;
    container?: RefObject<HTMLElement>;
}

export const ModalManager = ({
    modalProps,
    isModalShowing,
    closeModal,
    container
}: ModalManagerProps) => {
    const isForSaleSearch =
        modalProps.searchType === 'for-sale' ||
        modalProps.searchType === 'new-homes';

    const headerText = isForSaleSearch
        ? 'Search homes for sale'
        : 'Search homes to rent';

    return (
        <ControlledDialog
            label="Search Initiation"
            isOpen={isModalShowing}
            onClose={closeModal}
            container={container?.current}
            title={
                !modalProps.headlineText
                    ? modalProps.headerTextOverride || headerText
                    : ''
            }
        >
            <div className={contentWrapperStyle}>
                <SearchInitiationMobileModal
                    {...modalProps}
                    close={closeModal}
                />
            </div>
        </ControlledDialog>
    );
};
